import { Service } from '@dgx-pr-spa/shared/util';
import { createAction, props } from '@ngrx/store';

export const addExtra = createAction(
  '[Additional Services] Add Extra',
  props<{ payload: Service }>()
);

export const removeExtra = createAction(
  '[Additional Services] Remove Extra',
  props<{ payload: Service }>()
);

export const resetExtras = createAction('[Additional Services] Reset Extras');

export type ExtrasActions =
  | typeof addExtra
  | typeof removeExtra
  | typeof resetExtras;
